var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewProductSvg = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6841_26795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8874 8.0344L13.93 5.04492L4.1813 14.7937L3.18213 18.7926L7.18109 17.7923L16.8874 8.0344Z",
    stroke: "#08081B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9302 5.04205L15.3957 3.57653C15.5129 3.45822 15.6524 3.36431 15.8061 3.30022C15.9598 3.23612 16.1246 3.20312 16.2912 3.20312C16.4577 3.20312 16.6226 3.23612 16.7763 3.30022C16.93 3.36431 17.0694 3.45822 17.1866 3.57653L19.2491 5.66424L16.8876 8.03382",
    stroke: "#08081B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53174 14.4492L7.53153 17.449",
    stroke: "#08081B",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6841_26795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewProductSvg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NewProductSvg.5e2a54734ee2fd29d556d75c04102474.svg";